import { render, staticRenderFns } from "./SCHolidayFilters.vue?vue&type=template&id=260ba0b8"
import script from "./SCHolidayFilters.vue?vue&type=script&lang=js"
export * from "./SCHolidayFilters.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports